import { centralMenu } from '@core/_config/menu/central/central.menu';
import { TenantMenu } from '@core/_config/menu/tenant/tenant.menu';

export class MenuConfig {
  public defaults = {
    header: {
      self: {},
      items: [],
    },

    aside: {
      self: {},
      items: centralMenu,
      subdomain_items: TenantMenu,
    },
  };

  public get configs() {
    return this.defaults;
  }
}
